<template>
  <div style="padding:10px;" v-if="Array.isArray(items.blocks) && items.blocks.length > 0">
    <accordion :items="items.blocks">
      <template slot="item" slot-scope="{item, selected}">
        <div>
          <div class="search-container">
            <div class="search-icon" />
            <div class="input">
              <input :placeholder="placeholder" type="text" v-model="search">
            </div>
          </div>
          <flexcarousel :height="100" :draw="selected" :slides="item.options">
            <template slot="slide" slot-scope="{slide}">
              <div style="padding:5px 15px;display:flex;"
                :style="{backgroundColor: isSelected(slide)}">
                <input :value="slide" style="flex: 0 1;" :type="type"
                  :id="'accordionChecklist' + idHelper(slide.label)"
                  v-model="optSelected"
                >
                <label
                  :for="'accordionChecklist' + idHelper(slide.label)"
                  style="flex: 1 0;"
                >
                  {{slide.label}}
                </label>
              </div>
            </template>
          </flexcarousel>
        </div>
      </template>
    </accordion>
    <cancelaccept @accept="accept" @cancel="cancel" />
  </div>
</template>

<script>
import accordion from '../Accordion/Accordion.vue'
import flexcarousel from '../FlexCarousel/FlexCarousel.vue'
import cancelaccept from '../CancelAccept/CancelAccept.vue'

export default {
  components: {
    accordion,
    flexcarousel,
    cancelaccept
  },
  data () {
    return {
      optSelected: [],
      search: '',
      placeholder: window.civiiConf.accordionChecklistPlaceholder
    }
  },
  watch: {
    items () {
      if (this.items.type === 'checkbox') {
        this.optSelected = []
      } else if (this.items.type === 'radio') {
        this.optSelected = null
      }
    }
  },
  computed: {
    items () {
      let result = {}
      if (this.$store.state.accordionChecklist.type != null) {
        let self = this
        result = {type: this.$store.state.accordionChecklist.type}
        result.blocks = this.$store.state.accordionChecklist.blocks.map(
          function (block) {
            let nblock = {title: block.title}
            nblock.options = block.options.filter(
              (el) => el.label.toLowerCase().includes(self.search.toLowerCase()))
            return nblock
          }
        )
      }

      return result
    },
    type () {
      return this.items.type
    }
  },
  methods: {
    isSelected (value) {
      let color = 'rgba(0,0,0,0)'
      if ((this.items.type === 'checkbox' &&
        this.optSelected.includes(value)) ||
        (this.items.type === 'radio' &&
        this.optSelected === value)) {
        color = 'rgba(0,0,0,0.1)'
      }
      return color
    },
    idHelper (text) {
      return text.split(' ').join('')
    },
    async accept () {
      if ((this.type === 'checkbox' && this.optSelected.length > 0) ||
        (this.type === 'radio' && this.optSelected != null)) {
        this.$store.commit('addToContext', {'_input': this.optSelected})

        let message = ''
        if (this.type === 'checkbox') {
          message = this.optSelected.map(el => el.label).join(', ')
        } else if (this.type === 'radio') {
          message = this.optSelected.label
        }
        message = message.slice(0, Math.min(100, message.length))
        if (message.length > 99) message += ' ...'
        this.search = ''
        await this.$store.dispatch('sendMessage', {message})
      }
    },
    async cancel () {
      this.$store.commit('addToContext', {'_input': false})
      this.search = ''
      await this.$store.dispatch('sendMessage', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/AccordionChecklist/AccordionChecklist.vue